import { Icon } from "../Icon";
import { IIcon } from "../interfaces/IIcon";

export const filterIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M55.35 5.45 33.464 39.636V55.78l-2.926-1.636v-14.51L8.649 5.452h46.702ZM62 0H2A2 2 0 0 0 .316 3.078l24.052 37.565a2 2 0 0 1 .316 1.079v14.337a2 2 0 0 0 1.024 1.746l10.633 5.94A2 2 0 0 0 39.316 62V41.722a2 2 0 0 1 .316-1.079L63.684 3.078A2 2 0 0 0 62 0Z"/></svg>`
);
